import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["appear", "children", "dimension", "expanded", "getDimensionValue", "getScrollDimensionValue", "mountOnExpand", "onBeforeCollapse", "onBeforeExpand", "onCollapse", "onExpand", "timeout", "unmountOnCollapse"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Transition } from 'react-transition-group';
import React from 'react';
import defaultGetDimensionValue from '../utilities/getDimensionValue';
import defaultGetScrollDimensionValue from '../utilities/getScrollDimensionValue';
import triggerBrowserReflow from '../utilities/triggerBrowserReflow';
var defaultProps = {
  appear: false,
  dimension: 'height',
  expanded: false,
  getDimensionValue: defaultGetDimensionValue,
  getScrollDimensionValue: defaultGetScrollDimensionValue,
  mountOnExpand: false,
  // TODO: This should probably be controlled by the theme configuration.
  timeout: 300,
  unmountOnCollapse: false
};

var Collapse = /*#__PURE__*/function (_React$Component) {
  _inherits(Collapse, _React$Component);

  var _super = _createSuper(Collapse);

  function Collapse(props) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _super.call(this, props);
    _this.handleEnter = _this.handleEnter.bind(_assertThisInitialized(_this));
    _this.handleEntering = _this.handleEntering.bind(_assertThisInitialized(_this));
    _this.handleEntered = _this.handleEntered.bind(_assertThisInitialized(_this));
    _this.handleExit = _this.handleExit.bind(_assertThisInitialized(_this));
    _this.handleExiting = _this.handleExiting.bind(_assertThisInitialized(_this));
    _this.handleExited = _this.handleExited.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Collapse, [{
    key: "handleEnter",
    value: function handleEnter(element) {
      var onBeforeExpand = this.props.onBeforeExpand;
      var dimension = this.getDimension(); // eslint-disable-next-line no-param-reassign

      element.style[dimension] = '0';

      if (onBeforeExpand != null) {
        onBeforeExpand(element);
      }
    }
  }, {
    key: "handleEntering",
    value: function handleEntering(element) {
      var getScrollDimensionValue = this.props.getScrollDimensionValue;
      var dimension = this.getDimension();
      var value = getScrollDimensionValue(dimension, element); // eslint-disable-next-line no-param-reassign

      element.style[dimension] = "".concat(value, "px");
    }
  }, {
    key: "handleEntered",
    value: function handleEntered(element) {
      var onExpand = this.props.onExpand;
      var dimension = this.getDimension(); // eslint-disable-next-line no-param-reassign

      element.style[dimension] = '';

      if (onExpand != null) {
        onExpand(element);
      }
    }
  }, {
    key: "handleExit",
    value: function handleExit(element) {
      var _this$props = this.props,
          getDimensionValue = _this$props.getDimensionValue,
          onBeforeCollapse = _this$props.onBeforeCollapse;
      var dimension = this.getDimension();
      var value = getDimensionValue(dimension, element); // eslint-disable-next-line no-param-reassign

      element.style[dimension] = "".concat(value, "px"); // Reading a dimension property will cause the browser to recalculate,
      // which will let our animations work.

      triggerBrowserReflow(element);

      if (onBeforeCollapse != null) {
        onBeforeCollapse(element);
      }
    }
  }, {
    key: "handleExiting",
    value: function handleExiting(element) {
      var dimension = this.getDimension(); // eslint-disable-next-line no-param-reassign

      element.style[dimension] = '0';
    }
  }, {
    key: "handleExited",
    value: function handleExited(element) {
      var onCollapse = this.props.onCollapse;

      if (onCollapse != null) {
        onCollapse(element);
      }
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      var dimension = this.props.dimension;
      return typeof dimension === 'function' ? dimension() : dimension;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          appear = _this$props2.appear,
          children = _this$props2.children,
          dimension = _this$props2.dimension,
          expanded = _this$props2.expanded,
          getDimensionValue = _this$props2.getDimensionValue,
          getScrollDimensionValue = _this$props2.getScrollDimensionValue,
          mountOnExpand = _this$props2.mountOnExpand,
          onBeforeCollapse = _this$props2.onBeforeCollapse,
          onBeforeExpand = _this$props2.onBeforeExpand,
          onCollapse = _this$props2.onCollapse,
          onExpand = _this$props2.onExpand,
          timeout = _this$props2.timeout,
          unmountOnCollapse = _this$props2.unmountOnCollapse,
          unhandledProps = _objectWithoutProperties(_this$props2, _excluded);

      var rootStyles = function rootStyles(state) {
        return /*#__PURE__*/css({
          display: state === 'exited' ? 'none' : 'inherit',
          position: 'relative',
          overflow: 'hidden',
          transitionProperty: "".concat(_this2.getDimension(), ", visibility"),
          transitionDuration: "".concat(timeout, "ms"),
          transitionTimingFunction: 'ease'
        }, process.env.NODE_ENV === "production" ? "" : ";label:Collapse;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
      };

      return jsx(Transition, {
        appear: appear,
        in: expanded,
        mountOnEnter: mountOnExpand // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onEnter: this.handleEnter // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onEntering: this.handleEntering // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onEntered: this.handleEntered // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onExit: this.handleExit // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onExiting: this.handleExiting // eslint-disable-next-line @typescript-eslint/unbound-method
        ,
        onExited: this.handleExited,
        timeout: timeout,
        unmountOnExit: unmountOnCollapse
      }, function (state) {
        return jsx("div", _extends({}, unhandledProps, {
          css: rootStyles(state)
        }), React.Children.only(children));
      });
    }
  }]);

  return Collapse;
}(React.Component);

_defineProperty(Collapse, "defaultProps", defaultProps);

export default Collapse;